import { createSelector } from 'reselect';
import { AdministrationTenantCompany } from '@centecomm/portal-service';

import AccountState from './Types';
import { State } from '../../Types';

const administrationState = ({ administration }: State) => administration;

const administrationTenantCompanies = createSelector(
    administrationState,
    ({ tenantCompanies }: AccountState): AdministrationTenantCompany[] => tenantCompanies,
);

const administrationTenantCompaniesLoaded = createSelector(
    administrationState,
    ({ tenantCompaniesLoaded }: AccountState): boolean => tenantCompaniesLoaded,
);

export default {
    administrationTenantCompanies,
    administrationTenantCompaniesLoaded,
};
